import React, { useState } from "react";
import { FaEllipsis } from "react-icons/fa6";

import StickyContainer from "../../atoms/StickyContainer/StickyContainer";
import Logo from "../../molecules/Logo/Logo";
import Tooltip from "../Tooltip/Tooltip";

import { NavigationBarProps, NavigationBarTheme } from "./NavigationBar.types";
import { TooltipDirection } from "../Tooltip/Tooltip.types";

import "./NavigationBar.scss";

const NavigationBar: React.FC<NavigationBarProps> = ({
  links,
  activePath,
  ctaContainer,
  theme = NavigationBarTheme.admin,
}) => {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <StickyContainer backgroundColor="#fff" primaryNav={true}>
      <div className={`mp-organisms-navigationbar--main ${theme}`}>
        <Logo
          responsive={true}
          inverted={theme === NavigationBarTheme.student}
        />
        <div className={`link-container ${theme}`} data-testid="nav-bar">
          {
            <Links
              links={links}
              activePath={activePath}
              tooltip={false}
              setShowTooltip={undefined}
            />
          }
        </div>

        {links && links[0].length > 0 && (
          <div className="tooltip-container">
            <Tooltip
              show={showTooltip}
              close={() => setShowTooltip(false)}
              direction={TooltipDirection.bottom}
              content={
                <div style={{ padding: "1em 0em" }}>
                  <Links
                    links={links}
                    activePath={activePath}
                    tooltip={true}
                    setShowTooltip={setShowTooltip}
                  />
                </div>
              }
            >
              <div
                className={`link-tooltip-container ${theme}`}
                onClick={() => setShowTooltip(true)}
              >
                <FaEllipsis />
              </div>
            </Tooltip>
          </div>
        )}

        <div className="cta-container">{ctaContainer && ctaContainer}</div>
      </div>
    </StickyContainer>
  );
};

export default NavigationBar;

interface LinksProps {
  links: Array<any>;
  activePath: string | undefined;
  tooltip: boolean;
  setShowTooltip: ((value: boolean) => void) | undefined;
}
const Links = ({ links, activePath, tooltip, setShowTooltip }: LinksProps) => {
  return (
    <>
      {links.map((linkGroup: Array<any>, index: number) => {
        return (
          <div
            key={`link-group-${index}`}
            className={`link-group ${tooltip ? "tooltip" : ""}`}
          >
            {linkGroup.map((link, linkGroupIndex) => {
              const pathMatch = activePath
                ? `/${activePath.split(/\/|\?/)[1]}`
                : "";
              const toMatch = `/${link.props.to.split(/\/|\?/)[1]}`;

              return (
                <div
                  key={`link-group-link-${linkGroupIndex}`}
                  className={`link${
                    pathMatch.toLowerCase() === toMatch.toLowerCase()
                      ? " active"
                      : ""
                  }`}
                  onClick={() => {
                    if (setShowTooltip) {
                      setShowTooltip(false);
                    }
                  }}
                >
                  {link}
                </div>
              );
            })}
            <>
              {index < links.length - 1 && (
                <div className={`sep ${tooltip && "horizontal"}`} />
              )}
            </>
          </div>
        );
      })}
    </>
  );
};
